export const datetimeParaIso = (value) => {
    if (!value) return "";

    const match = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})$/);
    if (!match) return value;

    const [, dia, mes, ano, hora, minuto] = match;

    return `${ano}-${mes}-${dia} ${hora}:${minuto}:00`;
};

export const isoParaDatetimeExibicao = (value) => {
    if (!value) return "";

    const raw = String(value).slice(0, 16).replace(" ", "T");
    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
    if (!match) return "";

    const [, ano, mes, dia, hora, minuto] = match;

    return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
};

export const dataParaIso = (value) => {
    if (!value) return "";

    const match = String(value).match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (!match) return value;

    const [, dia, mes, ano] = match;

    return `${ano}-${mes}-${dia}`;
};
